import React from 'react'
import { Step as RCStep } from 'rc-steps'
import cx from 'classnames'

import * as styles from './step.module.css'

interface StepProps {
  title: string
  status?: string
}

const Step: React.FC<StepProps> = (props) => {
  const isFinished = props.status === 'finish'
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  //@ts-ignore
  return <RCStep className={cx(isFinished && styles.step)} {...props} />
}

export default Step
